import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

const HERO_BG =
  "https://images.unsplash.com/photo-1634834300387-8015d9fb7550?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxmdXR1cmlzdGljJTIwYWJzdHJhY3QlMjBBSSUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzgyMzcyNTI2fDA&ixlib=rb-4.1.0&q=85";

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-end pt-24 pb-16 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Futuristic AI"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/70 via-[#050505]/85 to-[#050505]" />
        <div className="absolute inset-0 grid-bg opacity-40" />
        <div className="noise-overlay" />
      </div>

      <div className="container-x relative">
        <div className="max-w-4xl">
          <div
            data-testid="hero-eyebrow"
            className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 font-mono-label text-[11px] text-[#00F0FF] mb-8"
          >
            <Sparkles size={12} /> AI · Product · Research
          </div>

          <h1
            data-testid="hero-heading"
            className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-white"
          >
            We build{" "}
            <span className="text-[#00F0FF] text-glow">intelligent systems</span>{" "}
            for industries that cannot afford to guess.
          </h1>

          <p
            data-testid="hero-subheading"
            className="mt-8 text-lg md:text-xl text-white/70 max-w-2xl leading-relaxed"
          >
            Pransam Technologies is a consulting and engineering studio for
            applied AI, product development and deep technology research —
            partnering with manufacturing, pharma, education and agritech
            leaders to move from pilot to production.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link
              to="/contact"
              data-testid="hero-cta-primary"
              className="inline-flex items-center gap-2 rounded-full bg-[#00F0FF] text-black font-semibold px-6 py-3.5 transition-transform duration-200 hover:-translate-y-0.5 hover-glow"
            >
              Start a project <ArrowRight size={16} />
            </Link>
            <Link
              to="/industries"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 text-white/90 px-6 py-3.5 transition-colors duration-200 hover:bg-white/10"
            >
              Explore industries
            </Link>
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl">
            {[
              { k: "4", v: "Industry verticals" },
              { k: "50+", v: "AI models shipped" },
              { k: "24/7", v: "Research team" },
              { k: "12wk", v: "Median time to prod" },
            ].map((s, idx) => (
              <div
                key={idx}
                data-testid={`hero-stat-${idx}`}
                className="border-l border-white/15 pl-4"
              >
                <div className="font-display text-3xl text-white">{s.k}</div>
                <div className="font-mono-label text-[10px] text-white/50 mt-1">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
